export default "__VITE_ASSET__fvORYhsg__"